
<style>
.inbound-steps .vview-icons-ios-checkmark-empty::before {
	content: "\F171";
}
</style>

<template>
    <div>
    <Steps :current="getCurIndex" class="bg-fff padding-20 inbound-steps" >
		<Step style="min-height:44px" v-for="(val,key) of progressStatus" :title="val.label" :key="key" :content="val.status ? val.actualTime: val.estimateTime"></Step>
	</Steps>
    <div v-if="getCurIndex == -1" style="position: absolute; top: 38%;left: 3.8%;padding-left: 20px;color: #999">暂未获取到物流信息</div>
    </div>

</template>

<script>
export default {
	props: ['status', 'needBox', 'nodeList'],
	computed: {
		getCurIndex() {
            return this.progressStatus.filter(item => item.status).length || -1
		},
		progressStatus() {
            const arr = [
                    {label: '开航', value: 'unBerthing', actualTime: '', estimateTime: '', status: ''},
                    {label: '到港', value: 'berthing', actualTime: '', estimateTime: '', status: ''},
                    {label: '卸柜', value: 'unloading', actualTime: '', estimateTime: '', status: ''},
                    {label: '重箱出场', value: 'placeHeavyOut', actualTime: '', estimateTime: '', status: ''},
                    {label: '入库', value: 'inbound', actualTime: '', estimateTime: '', status: ''},
                    {label: '空箱返场', value: 'placeEmptyBack', actualTime: '', estimateTime: '', status: ''},
            ]
            arr.map( item => {
                this.nodeList.map( node => {
                    if(node.name == item.value){
                        item.actualTime = node.actualTime ? '实际：' + node.actualTime : '';
                        item.estimateTime = node.estimateTime ? '预估：' + node.estimateTime : '';
                        item.status = node.status;
                    }
                })
                return item
            })
			return arr
		}
	}
}
</script>
